import { post } from '@/utils/request.js'

export const login_git = params => post("/api/vote/wxlogin", params)

export const login_info = params => post("/api/vote/info", params)

export const login_player_list = params => post("/api/vote/actionarticlelist", params)

export const login_player_search = params => post("/api/vote/playersearch", params)

export const login_player_action = params => post("/api/vote/actionarticlelist", params)

export const login_user = params => post("/api/vote/user", params)

export const login_move = params => post("/api/vote/actionarticleinfo", params)

export const login_useradd = params => post("/api/vote/useradd", params)

export const login_add = params => post("/api/common/uploadForUnionid", params)

export const login_share = params => post("/api/vote/shareCode", params)

export const login_vote = params => post("/api/vote/votelins", params)

export const login_site = params => post("/api/common/site", params)

export const login_complain = params => post("/api/vote/complain", params)

export const commentadd = params => post("/api/vote/commentadd", params)

export const commentlist = params => post("/api/vote/commentlist", params)

export const comment_thumbs = params => post("/api/vote/commentthumbs", params)

export const comment_thumbs_delete = params => post("/api/vote/commentthumbsdele", params)

export const actioninfo = params => post("/api/vote/actioninfo", params)

export const usercheck = params => post("/api/vote/usercheck", params)

export const thirdopenidcheck = params => post("/api/vote/thirdopenidcheck", params)

export const actioncode = params => post("/api/vote/actioncode", params)

export const site = params => post("/api/common/site", params)

export const searchAdvnologin = params => post("/api/advertisement/searchAdvnologin", params)

//获取活动分组
export const getGroup = params => post("/api/vote/usercategorylist", params)

export const robot = params => post("/api/common/google", params)

export const thirdurlcheck = params => post("/api/vote/thirdurlcheck", params)
//防刷验证/api/vote/veCode
export const verification = params => post("/api/vote/veCode", params)
// 广告获取 
export const ad = params => post('/api/advertisement/searchAdvnologin', params)
// 访问量
export const zclick = params => post('/api/vote/actionvisit', params)
// 腾讯验证 /api/vote/captchaCheck
export const tenxun = params => post('/api/vote/captchaCheck', params)
// 活动投票、点击率
export const topnum = params => post("/api/vote/actionticket", params)

// 分享记录
export const shareNum = params => post("/api/vote/actionsharecount", params)

// 图片转存
export const saveImg = params => post("/api/poster/copyImg", params)

// 评委登陆
export const JudgesLogin = params => post("/api/action/judgeslogin", params)

// 评委名下选手-评委 
export const judgesPlayer = params => post("/api/action/judgesuserinfofor", params)

// 评委打分
export const judGesscore = params => post("/api/action/judgesscore", params)

// 评审信息获取 
export const getJuInfo = params => post("/api/action/getreview", params)

//修改活动
export const changeAction = params => post("/api/action/actionedit", params)
//广告点击量增加
export const createHistory = params => post("/api/advertisement/createHistory", params)